<div class="composer" [ngClass]="{'composer-gravando': gravandoAudio}">

  <div class="composer-campo" [ngClass]="{'hidden': gravandoAudio}">
    <textarea
      type="text"
      [ngClass]="{'placeholder': !active}"
      class="chat-input-text"
      rows="1"
      [attr.maxlength]="limiteCaracteres"
      placeholder="Digite sua mensagem"
      #message
      (keydown)="verificaEnter($event)"
      (keyup.escape)="dismiss.emit()"
      (input)="verifyText($event)"></textarea>
  </div>

  <div class="composer-barra">

    <div class="composer-acoes">

      <div *ngIf="!gravandoAudio" class="tooltip-wrapper">
        <button type="button" class="composer-icone"
          [ngClass]="{'composer-icone-inativo': !hasGuid}"
          aria-label="Anexar arquivo"
          (click)="hasGuid && file.click()">
          <mat-icon svgIcon="attach_file"></mat-icon>
        </button>
        <div class="custom-tooltip" *ngIf="!hasGuid">
          A conversa precisa estar inicializada para enviar anexos
        </div>
      </div>

      <button *ngIf="!gravandoAudio" type="button" class="composer-icone"
        aria-label="Emojis"
        (mousedown)="$event.stopPropagation()"
        (click)="isEmojiPickerVisible = !isEmojiPickerVisible;">
        <mat-icon svgIcon="emoji_emotions"></mat-icon>
      </button>

      <div class="tooltip-wrapper">
        <chat-audio
          [disabled]="!hasGuid"
          [ngClass]="{'chat-audio-centralizado': gravandoAudio, 'chat-audio-submit': !gravandoAudio, 'composer-icone-inativo': !hasGuid}"
          (inicioGravacao)="onInicioGravacao()"
          (fimGravacao)="onFinalizarGravacao()"
          (aoGravar)="enviarAudio($event)">
        </chat-audio>
        <div class="custom-tooltip" *ngIf="!hasGuid">
          A conversa precisa estar inicializada para enviar áudios
        </div>
      </div>

    </div>

    <span class="composer-contador" *ngIf="mostrarContador && !gravandoAudio"
      [class.composer-contador-limite]="caracteresRestantes <= 0">
      {{ caracteresRestantes }}
    </span>

    <button
      *ngIf="!gravandoAudio"
      [ngClass]="{'chat-input-submit-active': active}"
      type="submit"
      class="chat-input-submit"
      aria-label="Enviar mensagem"
      (click)="onSubmit()">
      <mat-icon svgIcon="send"></mat-icon>
    </button>

  </div>
</div>

<input class="hidden" type="file" id="anexoChat" (change)="selecionarAnexo($event)" #file>

<div class="box-anexos" [ngClass]="{'hidden': !anexoSelecionado}">

  <div class="anexo-preview-header">

    <div class="anexo-preview-header-info">
      <mat-icon
        svgIcon="attach_file"
        class="icons anexo-preview-header-icone">
      </mat-icon>

      <div class="anexo-preview-header-texto">
        <span class="anexo-preview-header-titulo">
          Anexo
        </span>

        <span class="anexo-preview-header-subtitulo">
          {{ listaAnexosSelecionados.length }}
          {{ listaAnexosSelecionados.length === 1 ? 'arquivo selecionado' : 'arquivos selecionados' }}
        </span>
      </div>
    </div>

    <mat-icon
      svgIcon="close"
      class="icons fechar-anexo"
      (click)="fecharAnexo()">
    </mat-icon>

  </div>

  <div class="preview-arquivo">

    <ng-container *ngIf="listaAnexosSelecionados.length > 0">

      <ng-container *ngFor="let item of listaAnexosSelecionados; let i = index">

        <div
          *ngIf="i == indiceAnexo"
          class="anexo-preview">

          <div class="icone-anexo">
            <mat-icon
              svgIcon="description"
              class="icons">
            </mat-icon>
          </div>

          <div
            class="item-name"
            [title]="item.name">
            {{item.name}}
          </div>

          <div class="anexo-preview-dados">

            <span
              *ngIf="getExtensaoAnexo(item.name) != ''"
              class="anexo-dados-tipo">
              {{getExtensaoAnexo(item.name)}}
            </span>

            <span class="anexo-dados-tamanho">
              {{formataBytes(item.size)}}
            </span>

          </div>

        </div>

      </ng-container>

    </ng-container>

  </div>

  <div class="input-anexo">

    <emoji-mart
      #emojiAnexo
      class="emoji-mart-anexo"
      *ngIf="isAnexoEmojiPickerVisible"
      (emojiSelect)="addEmoji($event, true)"
      title="Choose your emoji"
      [i18n]="traducaoEmoji"
      [darkMode]="false">
    </emoji-mart>

    <mat-icon
      svgIcon="emoji_emotions"
      class="icons"
      (mousedown)="$event.stopPropagation()"
      (click)="isAnexoEmojiPickerVisible = !isAnexoEmojiPickerVisible;">
    </mat-icon>

    <textarea
      type="text"
      placeholder="Legenda (opcional)"
      class="input-anexo-text"
      [value]="listaAnexosSelecionados[indiceAnexo]?.legenda || ''"
      (input)="atualizarLegendaAnexo($event)"
      (keydown)="verificaEnter($event, true)"
      #messageAnexo>
    </textarea>

  </div>

  <div class="acoes-anexo px-2">

    <mat-icon
      svgIcon="attach_file"
      class="icons adicionar-anexo"
      (click)="file.click()">
    </mat-icon>

    <span
      *ngIf="listaAnexosSelecionados.length > 3"
      class="anexo-contador">
      {{ indiceAnexo + 1 }} de {{ listaAnexosSelecionados.length }}
    </span>

    <mat-icon
      svgIcon="arrow_back_ios"
      class="icons"
      [ngClass]="{'anexo-seta-inativa': indiceAnexo == 0}"
      (click)="voltaAnexo()">
    </mat-icon>

    <div class="anexos-slide overflow-hidden">

      <ng-container
        *ngFor="let item of listaAnexosSelecionados; let i = index">

        <ng-container
          *ngIf="
            i >= indiceAnexo - 2 &&
            i <= indiceAnexo + 2
          ">

          <div
            class="shrink-0 anexo-slide-item"
            [ngClass]="{
              'slide-selecionado': i === indiceAnexo
            }"
            (click)="selecionarAnexoIndice(i)">

            <mat-icon
              svgIcon="description"
              class="icons">
            </mat-icon>

          </div>

        </ng-container>

      </ng-container>

    </div>

    <mat-icon
      svgIcon="arrow_forward_ios"
      class="icons"
      [ngClass]="{'anexo-seta-inativa': indiceAnexo == listaAnexosSelecionados.length -1}"
      (click)="passaAnexo()">
    </mat-icon>

    <mat-icon
      svgIcon="send"
      class="icons enviar-anexo"
      (click)="enviarAnexo(listaAnexosSelecionados)">
    </mat-icon>

  </div>

</div>

<emoji-mart
  #emoji
  class="emoji-mart-principal"
  *ngIf="isEmojiPickerVisible"
  (emojiSelect)="addEmoji($event)"
  title="Choose your emoji"
  [i18n]="traducaoEmoji"
  [darkMode]="false"
></emoji-mart>
